// Dependencies
import styled, { css } from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const WrapInput = styled.div<{ isActive: boolean }>`
  height: 82px;

  #wrapper {
    width: 100%;
    display: flex;
    gap: 4px;
    align-items: flex-start;
    flex-direction: column;

    .texts {
      grid-area: texts;
      align-items: flex-start;
    }
  }

  #subject {
    color: #000;
    font-family: 'Source Sans 3';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  input {
    border: 1px solid #ced0dd;
    box-sizing: border-box;
    border-radius: 8px;
    height: 48px;
    width: 100%;
    text-align: center;

    color: #25272d;
    text-align: center;
    font-family: 'Source Sans 3';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }

  #ready {
    font-size: 10px;
    line-height: 22px;
    font-weight: 400;
    color: #6b6b84;
    display: none;
  }

`

export const SelectOptionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`

export const SelectOptionLabel = styled.p<{
  isDisabled: boolean
}>`
  font-family: 'Source Sans 3';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      color: #ced0dd;
    `}

  ${({ isDisabled }) =>
    !isDisabled &&
    css`
      color: #000;
    `}
`

export const SelectOption = styled.select<{
  isDisabled: boolean
}>`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ced0dd;
  background: #fff;
  box-sizing: border-box;
  font-family: 'Source Sans 3';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      color: #ced0dd;
    `}

  ${({ isDisabled }) =>
    !isDisabled &&
    css`
      color: #7c8195;
      cursor: pointer;
    `}

  option {
    width: 100%;
    background: #fff;
    color: #000;
  }
`
